import { DataTableMeta, DateColumn, ElementsGroup, Chip } from '@otp/ui';
import { Reload } from '@otp/icons';
import { TFunction } from 'i18next';
import React from 'react';

import { ActionsColumn } from './columns/actions';
import { StoreModel, User } from 'src/graphql/generated/graphql';
import { getFullName } from 'src/utils/user-data';
import { PartialMostScheduledJobListType } from 'src/components/most/list/scheduled-jobs/types';
import { StoresField } from 'src/components/common/table/columns/stores';
import { DevicesField } from 'src/components/most/list/common/table/columns/devices';

export const getTableConfig = (
  mostScheduledJobs: PartialMostScheduledJobListType[],
  {
    t,
  }: {
    t: TFunction;
  },
) => [
  {
    name: 'schedule.nextRunAt',
    label: t('most.list.scheduled-jobs.table.next-run-at'),
    options: {
      customBodyRender: (nextRunAt: string, column: DataTableMeta) => {
        const mostScheduledJob = mostScheduledJobs[column.rowIndex];
        const { isRecurring } = mostScheduledJob;
        const dateValue = nextRunAt ? (
          <DateColumn date={nextRunAt} withTime />
        ) : null;

        return (
          <div className="flex items-center">
            {dateValue} {isRecurring && <Reload className="scale-75" />}
          </div>
        );
      },
    },
  },
  {
    name: 'jobConfig.stores',
    label: t('common.stores'),
    options: {
      customBodyRender: (stores: StoreModel[]) => {
        if (!stores?.length) {
          return null;
        }

        return <StoresField stores={stores} />;
      },
    },
  },
  {
    name: 'jobConfig.name',
    label: t('most.list.scheduled-jobs.table.request-type'),
  },
  {
    name: 'jobConfig.devices',
    label: t('common.devices'),
    options: {
      customBodyRender: (devices: string[]) => {
        if (!devices?.length) {
          return null;
        }

        return <DevicesField devices={devices} />;
      },
    },
  },
  {
    name: 'user',
    label: t('most.list.scheduled-jobs.table.scheduled-by'),
    options: {
      customBodyRender: (scheduledBy: User) => {
        return <div>{getFullName(scheduledBy)}</div>;
      },
    },
  },
  {
    name: 'actions',
    label: t('common.actions'),
    options: {
      customBodyRender: (_: any, column: DataTableMeta) => {
        const mostScheduledJob = mostScheduledJobs[column.rowIndex];

        return <ActionsColumn mostScheduledJob={mostScheduledJob} />;
      },
    },
  },
];
